import React from "react";
import { Link } from "react-router-dom";
import styles from "./Footer.module.css";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className={styles.footerContent}>
          <div className={styles.column}>
            <h3>Muigai Medical Center</h3>
            <p>
              Your health, our priority. Compassionate care with a modern
              approach.
            </p>
          </div>
          <div className={styles.column}>
            <h3>Quick Links</h3>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About</Link>
              </li>
              <li>
                <Link to="/services">Services</Link>
              </li>
              <li>
                <Link to="/telemedicine">Telemedicine</Link>
              </li>
              <li>
                <Link to="/appointment">Appointments</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>
          <div className={styles.column}>
            <h3>Legal</h3>
            <ul>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms-of-service">Terms of Service</Link>
              </li>
            </ul>
          </div>
          <div className={styles.column}>
            <h3>Contact Info</h3>
            <p>P.O. Box 5687 00200, Nairobi</p>
            <p>
              Tel: <a href="tel:+254722265791">+254 722 265791</a>
            </p>
            <p>Email: info@muigaiclinic.com</p>
          </div>
          <div className={styles.column}>
            <h3>Follow Us</h3>
            <div className={styles.social}>
              <a href="#" target="_blank" rel="noopener noreferrer">
                Facebook
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer">
                Twitter
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer">
                LinkedIn
              </a>
            </div>
          </div>
        </div>
        <div className={styles.bottom}>
          <p>
            &copy; {new Date().getFullYear()} Muigai Medical Center. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
